"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL PartnerService
 * The EMIL PartnerService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredError = exports.BaseAPI = exports.resetRetry = exports.Environment = exports.COLLECTION_FORMATS = exports.BASE_PATH = void 0;
var configuration_1 = require("./configuration");
var common_1 = require("./common");
// Some imports not used depending on template conditions
// @ts-ignore
var axios_1 = __importDefault(require("axios"));
exports.BASE_PATH = "https://apiv2.emil.de".replace(/\/+$/, "");
/**
 *
 * @export
 */
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
var Environment;
(function (Environment) {
    Environment["Production"] = "https://apiv2.emil.de";
    Environment["Test"] = "https://apiv2-test.emil.de";
    Environment["Staging"] = "https://apiv2-staging.emil.de";
    Environment["Development"] = "https://apiv2-dev.emil.de";
    Environment["ProductionZurich"] = "https://eu-central-2.apiv2.emil.de";
})(Environment = exports.Environment || (exports.Environment = {}));
var _retry_count = 0;
var _retry = null;
function resetRetry() {
    _retry_count = 0;
}
exports.resetRetry = resetRetry;
var NETWORK_ERROR_MESSAGE = "Network Error";
var TOKEN_DATA = 'APP_TOKEN';
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, axios) {
        if (basePath === void 0) { basePath = exports.BASE_PATH; }
        if (axios === void 0) { axios = axios_1.default; }
        this.basePath = basePath;
        this.axios = axios;
        this.loadTokenData();
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
            this.configuration.accessToken = this.tokenData.accessToken ? "Bearer ".concat(this.tokenData.accessToken) : '';
        }
        else {
            var _a = this.tokenData, accessToken = _a.accessToken, username = _a.username;
            this.configuration = new configuration_1.Configuration({
                basePath: this.basePath,
                accessToken: accessToken ? "Bearer ".concat(accessToken) : '',
                username: username,
            });
        }
        this.attachInterceptor(axios);
    }
    BaseAPI.prototype.selectEnvironment = function (env) {
        this.selectBasePath(env);
    };
    BaseAPI.prototype.selectBasePath = function (path) {
        this.configuration.basePath = path;
    };
    BaseAPI.prototype.getPermissions = function () {
        var _a;
        if (!((_a = this.tokenData) === null || _a === void 0 ? void 0 : _a.permissions)) {
            return [];
        }
        return this.tokenData.permissions.split(',');
    };
    BaseAPI.prototype.authorize = function (username, password) {
        return __awaiter(this, void 0, void 0, function () {
            var options, response, _a, accessToken, permissions;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        options = {
                            method: 'POST',
                            url: "".concat(this.configuration.basePath, "/authservice/v1/login"),
                            headers: { 'Content-Type': 'application/json' },
                            data: {
                                username: username,
                                password: password,
                            },
                            withCredentials: true,
                        };
                        return [4 /*yield*/, axios_1.default.request(options)];
                    case 1:
                        response = _b.sent();
                        _a = response.data, accessToken = _a.accessToken, permissions = _a.permissions;
                        this.configuration.username = username;
                        this.configuration.accessToken = "Bearer ".concat(accessToken);
                        this.tokenData.username = username;
                        this.tokenData.accessToken = accessToken;
                        this.tokenData.permissions = permissions;
                        this.storeTokenData(__assign({}, this.tokenData));
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseAPI.prototype.refreshTokenInternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var username, refreshTokenAxios, options, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        username = this.configuration.username;
                        if (!username) {
                            throw new Error('Failed to refresh token.');
                        }
                        refreshTokenAxios = axios_1.default.create();
                        refreshTokenAxios.interceptors.response.use(function (response) {
                            var permissions = response.data.permissions;
                            _this.tokenData.permissions = permissions;
                            _this.storeTokenData(_this.tokenData);
                            return response;
                        });
                        options = {
                            method: 'POST',
                            url: "".concat(this.configuration.basePath, "/authservice/v1/refresh-token"),
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            data: { username: username },
                            withCredentials: true,
                        };
                        return [4 /*yield*/, refreshTokenAxios.request(options)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    BaseAPI.prototype.storeTokenData = function (tokenData) {
        if (typeof window !== 'undefined') {
            (0, common_1.defaultStorage)().set(TOKEN_DATA, tokenData);
        }
    };
    BaseAPI.prototype.loadTokenData = function () {
        if (typeof window !== 'undefined') {
            this.tokenData = (0, common_1.defaultStorage)().get(TOKEN_DATA) || {};
        }
        else {
            this.tokenData = {};
        }
    };
    BaseAPI.prototype.cleanTokenData = function () {
        this.storeTokenData(null);
    };
    BaseAPI.prototype.attachInterceptor = function (axios) {
        var _this = this;
        axios.interceptors.response.use(function (res) {
            return res;
        }, function (err) { return __awaiter(_this, void 0, void 0, function () {
            var originalConfig, _a, tokenString, permissions, accessToken, _error_1, _b, tokenString, permissions, accessToken, _error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        originalConfig = err.config;
                        if (!(err.response && !(err.response instanceof XMLHttpRequest))) return [3 /*break*/, 5];
                        if (!((err.response.status === 401 || err.response.status === 403)
                            && !originalConfig._retry)) return [3 /*break*/, 4];
                        originalConfig._retry = true;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.refreshTokenInternal()];
                    case 2:
                        _a = _c.sent(), tokenString = _a.accessToken, permissions = _a.permissions;
                        accessToken = "Bearer ".concat(tokenString);
                        this.tokenData.permissions = permissions;
                        delete originalConfig.headers['Authorization'];
                        originalConfig.headers['Authorization'] = accessToken;
                        this.configuration.accessToken = accessToken;
                        this.tokenData.accessToken = tokenString;
                        this.storeTokenData(this.tokenData);
                        return [2 /*return*/, axios(originalConfig)];
                    case 3:
                        _error_1 = _c.sent();
                        if (_error_1.response && _error_1.response.data) {
                            return [2 /*return*/, Promise.reject(_error_1.response.data)];
                        }
                        return [2 /*return*/, Promise.reject(_error_1)];
                    case 4: return [3 /*break*/, 9];
                    case 5:
                        if (!(err.message === NETWORK_ERROR_MESSAGE
                            && originalConfig.headers.hasOwnProperty('Authorization')
                            && _retry_count < 4)) return [3 /*break*/, 9];
                        _retry_count++;
                        _c.label = 6;
                    case 6:
                        _c.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, this.refreshTokenInternal()];
                    case 7:
                        _b = _c.sent(), tokenString = _b.accessToken, permissions = _b.permissions;
                        accessToken = "Bearer ".concat(tokenString);
                        this.tokenData.permissions = permissions;
                        _retry = true;
                        originalConfig.headers['Authorization'] = accessToken;
                        this.configuration.accessToken = accessToken;
                        this.tokenData.accessToken = tokenString;
                        this.storeTokenData(this.tokenData);
                        return [2 /*return*/, axios.request(__assign({}, originalConfig))];
                    case 8:
                        _error_2 = _c.sent();
                        if (_error_2.response && _error_2.response.data) {
                            return [2 /*return*/, Promise.reject(_error_2.response.data)];
                        }
                        return [2 /*return*/, Promise.reject(_error_2)];
                    case 9: return [2 /*return*/, Promise.reject(err)];
                }
            });
        }); });
    };
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = "RequiredError";
        return _this;
    }
    return RequiredError;
}(Error));
exports.RequiredError = RequiredError;
